import { Currency } from "../services/support"
import { formatAmountFromCents } from "../services/promo"

import css from "../style.module.scss"

function joinClasses(...classes: Array<string | undefined>): string {
  return classes.filter(Boolean).join(" ")
}

export function PriceDisplay({
  originalAmount,
  discountedAmount,
  currency,
  className,
  originalClassName,
  discountedClassName,
}: {
  originalAmount: number
  discountedAmount: number
  currency: Currency
  className?: string
  originalClassName?: string
  discountedClassName?: string
}) {
  const content =
    originalAmount === discountedAmount ? (
      <span className={discountedClassName}>
        {currency.prefix}
        {formatAmountFromCents(discountedAmount)}
      </span>
    ) : (
      <>
        <span className={joinClasses(css["price-original"], originalClassName)}>
          {currency.prefix}
          {formatAmountFromCents(originalAmount)}
        </span>{" "}
        <span className={joinClasses(css["price-current"], discountedClassName)}>
          {currency.prefix}
          {formatAmountFromCents(discountedAmount)}
        </span>
      </>
    )

  if (!className) return content

  return <span className={className}>{content}</span>
}
